// Allows for env vars set via .env file (local) or injected at run time (deployed)

export const env = {
    VITE_MAP_STYLE:
    window?.config?.VITE_MAP_STYLE ??
    import.meta.env.VITE_MAP_STYLE ??
    "",
    VITE_BASE_API_URL:
    window?.config?.VITE_BASE_API_URL ??
    import.meta.env.VITE_BASE_API_URL ??
    "",
    VITE_EXTERNAL_API_URL:
    window?.config?.VITE_EXTERNAL_API_URL ??
    import.meta.env.VITE_EXTERNAL_API_URL ??
    "",
    VITE_PRECIP_TILES_BASE_URL:
    window?.config?.VITE_PRECIP_TILES_BASE_URL ??
    import.meta.env.VITE_PRECIP_TILES_BASE_URL ??
    "",
    VITE_PRECIP_TILES_SAS_TOKEN:
    window?.config?.VITE_PRECIP_TILES_SAS_TOKEN ??
    import.meta.env.VITE_PRECIP_TILES_SAS_TOKEN ??
    "",
    VITE_APP_ENVIRONMENT:
    window?.config?.VITE_APP_ENVIRONMENT ??
    import.meta.env.VITE_APP_ENVIRONMENT ??
    "",
    VITE_CYPRESS_USERNAME:
    window?.config?.VITE_CYPRESS_USERNAME ??
    import.meta.env.VITE_CYPRESS_USERNAME ??
    "",
    VITE_CYPRESS_PASSWORD:
    window?.config?.VITE_CYPRESS_PASSWORD ??
    import.meta.env.VITE_CYPRESS_PASSWORD ??
    "",
    VITE_FIRE_STORAGE_BASE_URL:
    window?.config?.VITE_FIRE_STORAGE_BASE_URL ??
    import.meta.env.VITE_FIRE_STORAGE_BASE_URL ??
    "",
    VITE_FIRE_STORAGE_SAS_TOKEN:
    window?.config?.VITE_FIRE_STORAGE_SAS_TOKEN ??
    import.meta.env.VITE_FIRE_STORAGE_SAS_TOKEN ??
    "",
};
